// extracted by mini-css-extract-plugin
export var measureBox = "_bs-0";